import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Radio from '@material-ui/core/Radio';
import Paper from '@material-ui/core/Paper';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import { Text } from 'recharts';
import Checkbox from '@material-ui/core/Checkbox';
import _ from 'lodash';
import StepBackButton from '../../components/atoms/StepBackButton';
import PublicFooter from '../../components/PublicFooter';
import { getAccounts } from '../../actions/Accounts';
import { isAuthenticated, sendLogin, signOut } from '../../auth/Auth';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { removeToken } from '../../libs/apis/UserApi';
import { getMenuSetting, updateMenuSetting } from '../../actions/GochiMenus';

const styles = () => ({
  '@global': {
    body: {
      backgroundColor: '#F7F7F7',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    }
  },
  main: {
    flexGrow: 1,
    maxWidth: 375,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 20
    // border: '1px solid #ccc'
  },
  page: {
    paddingLeft: 15,
    paddingRight: 15
  },
  paper: {
    display: 'flex',
    flexDirection: 'column'
  },
  titleGroup: {
    marginTop: 20,
    marginBottom: 20,
    display: 'flex',
    alignItems: 'flex-start'
  },
  pagerInDiv: {
    padding: '15px 10px'
  },
  linkToHome: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 50
  },
  bold: {
    fontWeight: 'bold'
  },
  font24: {
    fontSize: 24
  },
  font14: {
    fontSize: 14
  },
  btnBack: {
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: 20
  },
  btnSubmit: {
    padding: '20px 0'
  },
  ml10: {
    marginLeft: 10
  },
  rowRadio: {
    display: 'flex',
    flexWrap: 'no-wrap',
    paddingLeft: 15,
    paddingRight: 15
  },
  labelRadio: {
    fontSize: 14
  }
});

const priceForSetting = [1000, 3000, 5000, 10000];

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      cognitoUserId: state.cognitoUser.cognitoUserId
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getAccounts, getMenuSetting, updateMenuSetting },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('isInsertGochiTicket', 'setIsInsertGochiTicket', null),
  withState('insertPrice', 'setInsertPrice', {}),
  withState('disablePrice', 'setDisablePrice', {}),
  withState('isUseGochiPrice', 'setIsUseGochiPrice', null),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    },
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      if (this.props.menuSetting) {
        this.props.setIsInsertGochiTicket(
          _.get(this.props.menuSetting, 'autoGenMenuDefault', false)
        );
        this.props.setIsUseGochiPrice(
          _.get(this.props.menuSetting, 'allowMenuPrice', false)
        );
        this.props.setInsertPrice(
          _.reduce(
            _.get(this.props.menuSetting, 'ticketCategories', []),
            (res, val) => {
              res[val] = true;
              return res;
            },
            {}
          )
        );
        this.props.setDisablePrice(
          _.reduce(
            _.get(this.props.menuSetting, 'ticketCategories', []),
            (res, val) => {
              res[val] = true;
              return res;
            },
            {}
          )
        );
      }
      // this.props.updateOpenProgress(true);
      // this.props.updateLoading(true);
      // this.props.actions
      //   .getAccounts({
      //     cognitoUserId: this.props.cognitoUserId
      //       ? this.props.cognitoUserId
      //       : ''
      //   })
      //   .then(data => {
      //     this.props.checkSession(data);
      //     if (data.payload.accountStatus != null) {
      //       this.props.setReleased(data.payload.accountStatus.status);
      //     }
      //     this.props.updateOpenProgress(false);
      //     this.props.updateLoading(false);
      //   })
      //   .catch(() => {
      //     this.props.updateOpenProgress(false);
      //     this.props.updateLoading(false);
      //   });
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleRedirect,
    openProgress,
    updateOpenProgress,
    updateLoading,
    loading,
    resultMessage,
    setResultMessage,
    isInsertGochiTicket,
    setIsInsertGochiTicket,
    insertPrice,
    setInsertPrice,
    isUseGochiPrice,
    setIsUseGochiPrice,
    shopId,
    setOpenMenuSettingModal,
    disablePrice,
    actions
  }) => {
    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const signOutAction = async () => {
      // remove token
      const currentToken = localStorage.getItem('firebaseToken');
      removeToken({
        pushToken: currentToken
      })
        .then(() => {
          console.log('remove token success');
        })
        .catch(() => {
          console.log('remove token failed');
        });

      signOut();
      handleRedirect('/');
    };

    const settingMenu = () => {
      updateOpenProgress(true);
      updateLoading(true);
      const dataParams = {
        params: {
          allowMenuPrice: isUseGochiPrice ? 1 : 0,
          autoGenMenuDefault: isInsertGochiTicket ? 1 : 0,
          ticketCategories: _.reduce(
            insertPrice,
            (result, value, key) => {
              if (value) {
                result.push(parseInt(key, 10));
              }
              return result;
            },
            []
          )
        },
        shopId
      };
      console.log(dataParams);
      actions
        .updateMenuSetting(dataParams)
        .then(data => {
          actions.getMenuSetting(shopId).then(() => {
            // updateOpenProgress(false);
            setResultMessage(data.payload);
            updateLoading(false);
            setOpenMenuSettingModal(false);
          });
        })
        .catch(() => {
          updateOpenProgress(false);
          updateLoading(false);
          setOpenMenuSettingModal(false);
        });
    };

    const handleChangePrice = event => {
      setInsertPrice({
        ...insertPrice,
        [event.target.name]: event.target.checked
      });
    };

    return (
      <Container component="main" className={classes.main}>
        <CssBaseline />
        <div className={classes.page}>
          <Paper className={classes.paper} elevation={1}>
            <div className={classes.pagerInDiv}>
              <div className={classes.titleGroup}>
                <Typography className={classes.font14}>
                  金券として使用できる「ごちチケット」をメニューに自動作成しますか？
                </Typography>
              </div>
              <RadioGroup
                value={isInsertGochiTicket}
                onChange={e => {
                  setIsInsertGochiTicket(e.target.value === 'true');
                }}
              >
                <div className={classes.rowRadio}>
                  <FormControlLabel
                    value
                    control={<Radio color="primary" />}
                    label={
                      <Typography className={classes.labelRadio}>
                        作成する
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio color="primary" />}
                    label={
                      <Typography className={classes.labelRadio}>
                        作成しない
                      </Typography>
                    }
                    className={classes.ml10}
                  />
                </div>
              </RadioGroup>

              {isInsertGochiTicket && (
                <>
                  <div className={classes.titleGroup}>
                    <Typography className={classes.font14}>
                      作成したい金額のチケットを以下から選択してください（複数可）
                    </Typography>
                  </div>
                  <div className={classes.rowRadio}>
                    {priceForSetting.map(price => (
                      <FormControlLabel
                        key={_.random(true)}
                        value={price}
                        disabled={disablePrice[price]}
                        control={
                          <Checkbox
                            color="primary"
                            checked={!!insertPrice[price]}
                            onChange={handleChangePrice}
                            name={price.toString()}
                          />
                        }
                        label={
                          <Typography className={classes.labelRadio}>
                            {`${price}円`}
                          </Typography>
                        }
                      />
                    ))}
                  </div>
                </>
              )}

              <div className={classes.titleGroup}>
                <Typography className={classes.font14}>
                  お客様が任意の金額のチケットを購入できる「お値段ごち」を利用しますか？（開店後いつでも設定が変更できます）
                </Typography>
              </div>
              <RadioGroup
                value={isUseGochiPrice}
                onChange={e => {
                  setIsUseGochiPrice(e.target.value === 'true');
                }}
              >
                <div className={classes.rowRadio}>
                  <FormControlLabel
                    value
                    control={<Radio color="primary" />}
                    label={
                      <Typography className={classes.labelRadio}>
                        利用する
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio color="primary" />}
                    label={
                      <Typography className={classes.labelRadio}>
                        利用しない
                      </Typography>
                    }
                    className={classes.ml10}
                  />
                </div>
              </RadioGroup>
            </div>
            <Divider />
            <div className={classes.pagerInDiv}>
              <div className={classes.btnSubmit}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  onClick={settingMenu}
                >
                  <Text className={classes.bold}>設定</Text>
                </Button>
              </div>

              <div className={classes.btnBack}>
                <StepBackButton
                  onClickAction={() => setOpenMenuSettingModal(false)}
                />
              </div>
            </div>
          </Paper>
          <div className={classes.linkToHome}>
            <Button className={classes.button} onClick={signOutAction}>
              <Text className={[classes.bold, classes.font14]}>ログアウト</Text>
            </Button>
          </div>
        </div>

        <PublicFooter />
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </Container>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
